import { ChangeDetectionStrategy, Component, input } from "@angular/core";

@Component({
  selector: "app-loading",
  templateUrl: "./loading.component.html",
  styleUrls: ["./loading.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LoadingComponent {
  showLoading = input.required<boolean>();
}
